<!--
 * @Author: 赵健
 * @Date: 2021-03-09 10:31:51
 * @LastEditTime: 2021-03-09 15:00:59
 * @LastEditors: 赵健
 * @Description: 修改描述
 * @FilePath: \Develop1.0.1\src\views\profile\updatePassword\index.vue
-->

<template>
  <div>
    <um-bread-crumb />
    <el-card
      class="box-card"
      shadow="never"
    >
      <div
        slot="header"
        class="clearfix"
      >
        <span>修改密码</span>
      </div>
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        status-icon
        :rules="rules"
        label-width="150px"
        class="demo-ruleForm"
        size="small"
      >
        <el-form-item
          ref="oldUserPassword"
          label="旧密码"
          prop="oldPass"
        >
          <el-input
            v-model="ruleForm.oldPass"
            type="password"
            autocomplete="off"
            style="width:200px;"
            placeholder="请输入旧密码"
          />
        </el-form-item>
        <el-form-item
          ref="newUserPassword"
          label="新密码"
          prop="pass"
        >
          <el-input
            v-model="ruleForm.pass"
            type="password"
            autocomplete="off"
            style="width:200px;"
            placeholder="请输入新密码"
          />
        </el-form-item>
        <el-form-item
          label="确认密码"
          prop="checkPass"
        >
          <el-input
            v-model="ruleForm.checkPass"
            type="password"
            autocomplete="off"
            style="width:200px;"
            placeholder="请再次输入密码"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { userUpdateUserPassword } from '@/api/user'
export default {
  name: 'ProfileUpdatePassword',
  props: {},
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
        oldPass: '',
        pass: '',
        checkPass: ''
      },
      rules: {
        oldPass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        pass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 10, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          userUpdateUserPassword({
            currentPassword: this.ruleForm.oldPass,
            newPassword: this.ruleForm.checkPass,
            confirmPassword: this.ruleForm.checkPass
          })
            .then(d => {
              // this.$message.success('修改成功！')
              this.$confirm('密码修改成功，是否跳转登录页?', '提示', {
                confirmButtonText: '确定',
                showCancelButton: false,
                // cancelButtonText: '取消',
                type: 'success'
              }).then(() => {
                this.$store.dispatch('user/resetToken')
                this.$router.push('/login')
              }).catch(() => {
                this.$store.dispatch('user/resetToken')
                this.$router.push('/login')
              })
            })
            .catch(e => {
              this.$errorHandle(e)
            })
        } else {
          this.$message.error('请正确填写表单！')
          return false
        }
      })
    }
  }
}
</script>
